// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0fa8168e","147":"35d0743e","574":"8f3a384c","615":"2ae2fa5f","807":"c7ac2574","818":"1e922dbc","899":"64901749","900":"65981b8d","952":"11dfc6d2"}[chunkId] + ".chunk.js";
};